/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createValidationProblemDetailsFromDiscriminatorValue, serializeAllotmentUpgradeRequest, type AllotmentUpgradeRequest, type ValidationProblemDetails } from '../models/index.js';
// @ts-ignore
import { TourOperatorsRequestBuilderRequestsMetadata, type TourOperatorsRequestBuilder } from './tourOperators/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /AllotmentUpgrade
 */
export interface AllotmentUpgradeRequestBuilder extends BaseRequestBuilder<AllotmentUpgradeRequestBuilder> {
    /**
     * The TourOperators property
     */
    get tourOperators(): TourOperatorsRequestBuilder;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ArrayBuffer>}
     * @throws {ValidationProblemDetails} error when the service returns a 400 status code
     */
     post(body: AllotmentUpgradeRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<ArrayBuffer | undefined>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: AllotmentUpgradeRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const AllotmentUpgradeRequestBuilderUriTemplate = "{+baseurl}/AllotmentUpgrade";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const AllotmentUpgradeRequestBuilderNavigationMetadata: Record<Exclude<keyof AllotmentUpgradeRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    tourOperators: {
        requestsMetadata: TourOperatorsRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const AllotmentUpgradeRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: AllotmentUpgradeRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendPrimitive",
        responseBodyFactory:  "ArrayBuffer",
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeAllotmentUpgradeRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
